import { useMemo } from 'react';

/**
 * OpFieldsList — render dei campi di un'operazione del coach (anteprima
 * "Sto per salvare"). Filtra le chiavi private (`_ripartizione`, …) e
 * memoizza il calcolo per evitare di rifare entries+filter ad ogni render.
 *
 * Usato dalle 4 chat (Setup / Quarterly / Monthly / Weekly) e dallo
 * Storico Coach. Il rendering è volutamente identico ovunque.
 */
export default function OpFieldsList({ campi }) {
  const entries = useMemo(
    () => Object.entries(campi || {}).filter(([k]) => !k.startsWith('_')),
    [campi],
  );
  if (entries.length === 0) return null;
  return (
    <div className="mt-1 ml-2 text-soft">
      {entries.map(([k, v]) => (
        <div key={k} className="flex gap-2">
          <span className="text-mute">{k}:</span>
          <span className="text-ink">{typeof v === 'string' ? v : JSON.stringify(v)}</span>
        </div>
      ))}
    </div>
  );
}
